import React from 'react';

const MonitorContext = React.createContext({
  monitor: '',
});
export default MonitorContext;
